import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { DetailTableColumn } from 'src/app/components/modal-carbon-credit-detail/modal-carbon-credit-detail.component';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

export interface WithdrawalBeneficiaryRow {
  cpfCnpj?: string;
  documentNumber?: string;
  withdrawalName?: string;
  beneficiaryName?: string;
  amount?: string | number;
  withdrawalAmount?: string | number;
  description?: string;
  beneficiaryDescription?: string;
  foreigner?: boolean;
  foreignerIndicator?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-modal-beneficiaries-table',
  templateUrl: './modal-beneficiaries-table.component.html',
  styleUrls: ['./modal-beneficiaries-table.component.scss'],
})
export class ModalBeneficiariesTableComponent implements AfterViewInit {
  readonly title = 'Detalhes do Crédito de Carbono';
  readonly columns: DetailTableColumn[] = [
    { label: 'CPF/CNPJ ou Tax ID', flex: 179 },
    { label: 'Nome', flex: 182 },
    { label: 'Quant.', flex: 124 },
    { label: 'Descrição', flex: 124 },
  ];

  rows: WithdrawalBeneficiaryRow[] = [];
  comitente = '';

  constructor(
    public dialogRef: AppModalOverlayRef<ModalBeneficiariesTableComponent>,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.rows = this.dialogRef?.data?.data ?? [];
    this.comitente = this.dialogRef?.data?.comitente ?? '';
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  getCpfCnpj(row: WithdrawalBeneficiaryRow): string {
    return row.cpfCnpj ?? row.documentNumber ?? '';
  }

  getNome(row: WithdrawalBeneficiaryRow): string {
    return row.withdrawalName ?? row.beneficiaryName ?? '';
  }


  getQuantidade(row: WithdrawalBeneficiaryRow): string | number {
    return row.amount ?? row.withdrawalAmount ?? '';
  }

  getDescricao(row: WithdrawalBeneficiaryRow): string {
    return row.description ?? row.beneficiaryDescription ?? '';
  }
}
